import React from 'react'
import { DefaultTheme, ThemeProvider } from 'styled-components'

const theme: DefaultTheme = {
  colors: {
    'primary-100': '#FCFEF6',
    'primary-200': '#DBEF9F',
    'primary-300': '#DBEF9F',
    'primary-400': '#CBE873',
    'primary-500': '#BBE148',
    'primary-600': '#607E03',
    'secondary-600': '#245121',
    'secondary-400': '#40863C',
    'secondary-300': '#50A94B',
    'secondary-200': '#91CD8E',
    'secondary-100': '#EDF6ED',
    'gray-100': '#F7F7F7',
    'gray-200': '#C4C4C4',
    'gray-300': '#919191',
    'gray-400': '#5E5E5E',
    'gray-500': '#2A2A2A',
    'sdg1-100': '#fde9ea',
    'sdg1-200': '#f6a7ac',
    'sdg1-300': '#f17a83',
    'sdg1-400': '#ed4e59',
    'sdg1-500': '#e82230',
    'sdg1-600': '#b30a16',
    'sdg1-700': '#4d0409',
    'sdg2-100': '#faf6eb',
    'sdg2-200': '#f6ecd7',
    'sdg2-300': '#e3c788',
    'sdg2-400': '#d9b460',
    'sdg2-500': '#d0a138',
    'sdg2-600': '#6f5211',
    'sdg2-700': '#5b440f',
    'sdg3-100': '#e9f5ed',
    'sdg3-200': '#a5d7b8',
    'sdg3-300': '#79c494',
    'sdg3-400': '#4cb071',
    'sdg3-500': '#1f9c4d',
    'sdg3-600': '#0f632e',
    'sdg3-700': '#073116',
    'sdg4-100': '#f9e9ea',
    'sdg4-200': '#e8a7ac',
    'sdg4-300': '#dc7c83',
    'sdg4-400': '#d15059',
    'sdg4-500': '#c52430',
    'sdg4-600': '#a7202a',
    'sdg4-700': '#540b11',
    'sdg5-100': '#fdecea',
    'sdg5-200': '#f7b3ab',
    'sdg5-300': '#f38e82',
    'sdg5-400': '#ef6858',
    'sdg5-500': '#eb422e',
    'sdg5-600': '#9a1f11',
    'sdg5-700': '#5f130a',
    'sdg6-100': '#e8f7fb',
    'sdg6-200': '#a4def0',
    'sdg6-300': '#77cde9',
    'sdg6-400': '#49bde1',
    'sdg6-500': '#1cacda',
    'sdg6-600': '#0c607a',
    'sdg6-700': '#063c4e',
    'sdg7-100': '#fdf7eb',
    'sdg7-200': '#f9dfad',
    'sdg7-300': '#f5d085',
    'sdg7-400': '#f2c05c',
    'sdg7-500': '#efb033',
    'sdg7-600': '#704a00',
    'sdg7-700': '#704a00',
    'sdg8-100': '#f6e9ec',
    'sdg8-200': '#ecd2da',
    'sdg8-300': '#d9a6b5',
    'sdg8-400': '#c7798f',
    'sdg8-500': '#b44d6a',
    'sdg8-600': '#a12045',
    'sdg8-700': '#581125',
    'sdg9-100': '#fdf0eb',
    'sdg9-200': '#f9c4b0',
    'sdg9-300': '#f6a688',
    'sdg9-400': '#f38961',
    'sdg9-500': '#f06b39',
    'sdg9-600': '#993611',
    'sdg9-700': '#461806',
    'sdg10-100': '#fce9f3',
    'sdg10-200': '#f2a5cd',
    'sdg10-300': '#eb79b5',
    'sdg10-400': '#e54c9c',
    'sdg10-500': '#de1f83',
    'sdg10-600': '#a30d5b',
    'sdg10-700': '#51022c',
    'sdg11-100': '#fef5eb',
    'sdg11-200': '#fbd7b0',
    'sdg11-300': '#fac489',
    'sdg11-400': '#f8b061',
    'sdg11-500': '#f69c3a',
    'sdg11-600': '#723f08',
    'sdg11-700': '#723f08',
    'sdg12-100': '#f8f4eb',
    'sdg12-200': '#e5d1af',
    'sdg12-300': '#d8bb87',
    'sdg12-400': '#cba45f',
    'sdg12-500': '#be8d37',
    'sdg12-600': '#725116',
    'sdg12-700': '#3f2d0c',
    'sdg13-100': '#ecf2ed',
    'sdg13-200': '#b4ccb6',
    'sdg13-300': '#8eb292',
    'sdg13-400': '#69996d',
    'sdg13-500': '#437f49',
    'sdg13-600': '#2c5a31',
    'sdg13-700': '#1b391e',
    'sdg14-100': '#eaf5fb',
    'sdg14-200': '#a9d6ed',
    'sdg14-300': '#7fc1e4',
    'sdg14-400': '#54addb',
    'sdg14-500': '#2998d2',
    'sdg14-600': '#185c80',
    'sdg14-700': '#0e394f',
    'sdg15-100': '#eff8ed',
    'sdg15-200': '#bee3b8',
    'sdg15-300': '#9ed595',
    'sdg15-400': '#7dc771',
    'sdg15-500': '#5db94e',
    'sdg15-600': '#24541c',
    'sdg15-700': '#173911',
    'sdg16-100': '#e8f0f5',
    'sdg16-200': '#a3c4d8',
    'sdg16-300': '#76a6c4',
    'sdg16-400': '#4889b1',
    'sdg16-500': '#1a6b9d',
    'sdg16-600': '#0e537e',
    'sdg16-700': '#08314b',
    'sdg17-100': '#e8edf0',
    'sdg17-200': '#d1dbe1',
    'sdg17-300': '#a3b7c3',
    'sdg17-400': '#7492a6',
    'sdg17-500': '#466e88',
    'sdg17-600': '#184a6a',
    'sdg17-700': '#0e2d40',
  },
}

const Theme = ({ children }: { children: React.ReactNode }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default Theme
